import { matchPath } from 'react-router';
import { createRoute } from './createRoute';
import { generatePath } from './generatePath';

export interface MicroCategoryPageParams {
  page: number;
  microCategorySlug: string;
}

export interface MicroCategoryPage {
  routeName: 'microCategory';
  params: MicroCategoryPageParams;
}

export const microCategoryRoute = createRoute<MicroCategoryPageParams, 'microCategorySlug'>({
  pattern: '/refine/:microCategorySlug/:page?',
  build: (pattern, params) => {
    const { page, microCategorySlug } = params;

    const pathParams = {
      page: page == null || page === 1 ? null : String(page),
      microCategorySlug: (microCategorySlug || '').toLowerCase(),
    };

    return { pathname: generatePath(pattern, pathParams), search: '' };
  },
  match: (pattern, location) => {
    const { pathname } = location;
    const match = matchPath({ path: pattern }, pathname);

    if (!match) {
      return null;
    }

    // See categoryRoute: re-validate the now-unconstrained `:page?` segment.
    const { page } = match.params;
    if (page !== undefined && !/^\d+$/.test(page)) {
      return null;
    }

    const requestedPage = Number(page);
    return {
      microCategorySlug: decodeURIComponent(match.params.microCategorySlug ?? ''),
      page: requestedPage || 1,
    };
  },
});
